import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

/**
 * Fetches the starter questions shown in the empty chat state
 * (`GET /aiball_chat/chat/suggestions/`). The backend returns them already
 * localized for the `Language-Code` header, so callers can render them as-is.
 */
@Injectable({
  providedIn: "root",
})
export class GetChatSuggestionsWS {
  constructor(
    private baseHandler: BaseHandler,
    private translateService: TranslateService
  ) {}

  execute(token: string): Observable<string[]> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.CHAT_SUGGESTIONS_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .addHeader("Language-Code", this.languageCode())
      .build();

    return this.baseHandler
      .execute(parameters)
      .pipe(
        map((response: { suggestions: string[] }) => response?.suggestions ?? [])
      );
  }

  private languageCode(): string {
    return (
      this.translateService.currentLang ||
      this.translateService.getBrowserLang() ||
      ""
    );
  }
}
